<template>
    <div>
        <app-toolbar :toolbar="toolbar"></app-toolbar>
        <v-container fluid>
        <!-- mainTable Start -->
            <v-simple-table class="mainTable" fixed-header height="75vh">
                <thead>
                    <tr>
                        <th v-show="editMode" width="20"></th>
                        <th v-show="editMode" width="20">EDIT</th>
                        <th>NAME</th>
                        <th v-show="viewMode">VALUE</th>
                        <th v-show="viewMode">HOUSE TYPE</th>
                        <th v-show="viewMode">CREATED</th>
                        <th v-show="viewMode">UPDATED</th>
                        <th v-show="viewMode">CREATED BY</th>
                        <th v-show="viewMode">UPDATED BY</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(ITEM, i) in LOUVER_ITEMS" :key="i">
                        <td v-show="editMode">
                            <v-checkbox v-model="ITEM.selected" dense></v-checkbox>
                        </td>
                        <td v-show="editMode"> 
                            <v-btn
                                fab
                                x-small
                                @click="toggleUpdateDialog(ITEM)">
                                <v-icon >mdi-pencil</v-icon> 
                            </v-btn>
                        </td>
                        <td> {{ ITEM.louver_name }} </td>
                        <td v-show="viewMode"> {{ ITEM.louver_value }} </td>
                        <td v-show="viewMode">
                            <v-chip class="mx-1 font-weight-bold" small v-for="(SUBITEM,ii) in ITEM.louverhouse" :key="`${i}-${ii}`">
                                {{ SUBITEM.louver_house }}
                            </v-chip>
                        </td>
                        <td v-show="viewMode"> {{ formatDate(ITEM.created_at) }} </td>
                        <td v-show="viewMode"> {{ formatDate(ITEM.updated_at) }} </td>
                        <td v-show="viewMode"> {{ ITEM.created_by }} </td>
                        <td v-show="viewMode"> {{ ITEM.updated_by }} </td>
                    </tr>
                </tbody>
            </v-simple-table>
        <!-- mainTable End -->

        </v-container>

        <!-- Dialogs -->

        <!-- dialogStore Start -->
        <v-dialog v-model="dialogStore" max-width="300" persistent>
            <v-form id="Store" ref="Store" @submit.prevent="Store">
                <v-card>
                    <v-card-title> <span class="overline">Create Louver Item</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field 
                                        outlined 
                                        dense 
                                        label="Louver Name"
                                        name="louver_name" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field 
                                        outlined 
                                        dense 
                                        label="Louver Value"
                                        name="louver_value" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        :items="HOUSE_TYPES"
                                        item-value="id"
                                        item-text="name"
                                        outlined 
                                        multiple 
                                        label="House Type"
                                        name="house_type_id" 
                                        class="required"
                                        :rules="rules.required"
                                        chips
                                        small-chips
                                        deletable-chips
                                    > </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogStore = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogStore End -->

        <!-- dialogUpdate Start -->
        <v-dialog v-model="dialogUpdate" max-width="300" persistent>
            <v-form id="Update" ref="Update" @submit.prevent="Update">
                <v-card>
                    <v-card-title> <span class="overline">Edit Louver Item</span> </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field 
                                        v-model="tempData.louver_name"
                                        outlined 
                                        dense 
                                        label="Louver Name"
                                        name="louver_name" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field 
                                        v-model="tempData.louver_value"
                                        outlined 
                                        dense 
                                        label="Louver Value"
                                        name="louver_value" 
                                        class="required"
                                        :rules="rules.required"
                                    > </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-autocomplete
                                        v-model="tempData.house_type_id"
                                        :items="HOUSE_TYPES"
                                        item-value="id"
                                        item-text="name"
                                        outlined 
                                        multiple 
                                        label="House Type"
                                        name="house_type_id" 
                                        class="required"
                                        :rules="rules.required"
                                        chips
                                        small-chips
                                    > </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogUpdate = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogUpdate End -->

        <!-- dialogDelete Start -->
        <v-dialog v-model="dialogDelete" max-width="300" persistent>
            <v-form id="Delete" ref="Delete" @submit.prevent="Delete">
                <v-card>
                    <v-card-title> <span class="overline">delete</span> </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <span class="overline font-weight-black"> Delete Selected Items? </span>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text type="submit">保存</v-btn>
                        <v-btn text @click="dialogDelete = false">キャンセル</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!-- dialogDelete End -->

        <app-buttons  
            @toggleDialogDelete="toggleDialogDelete"
            @toggleDialogStore="toggleDialogStore" 
            :selectedData="selectedData"
            :floatButtons="floatButtons"
        > 
        </app-buttons>
        <app-footer :items="LOUVER_ITEMS.length"></app-footer>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import ToolbarMenu from '../../modules/ToolbarMenu.vue';
import Footer from '../../modules/Footer.vue';
import FloatingButtons from '../../modules/FloatingButtons.vue';
    export default {
        components: {
            'app-toolbar': ToolbarMenu,
            'app-buttons': FloatingButtons,
            'app-footer': Footer
        },
        data: () => ({
            toolbar: {
                title: 'LOUVER ITEMS (ルーバー)',
                view: true,
                back: true,
                filter: false,
                master: false,
            },

            floatButtons:{
                add: true,
                update: true,
                delete: true
            },

            //temp data storage
            tempData: {},
            dialogStore: false,
            dialogUpdate: false,
            dialogDelete: false

        }),

        computed : {
            ...mapState([
                'LOUVER_ITEMS',
                'HOUSE_TYPES',
                'rules',
                'editMode',
                'viewMode'
            ]),

            selectedData(){
                // this will return only the id of the selected data
                return this.LOUVER_ITEMS.filter(res => res.selected).map(res => res.id); 
            }
        },


        methods: {
            ...mapActions([
                '_getLouverItems',
                '_getHouseTypes',
            ]),

            formatDate(val){
                return new Date(val).toLocaleString('en-US', { timeZone: 'Asia/Manila', hour12: false })
            },

            toggleDialogStore(val){
                this.dialogStore = val;
            },

            Store(){
                if(this.$refs.Store.validate()){
                    const myForm = document.getElementById('Store');
                    const formdata = new FormData(myForm);

                    axios({
                        method: 'POST',
                        url: '/api/louver_items/store',
                        data: formdata
                    }).then(() => {
                        this._getLouverItems();
                        this.dialogStore = false;
                    })
                }
            },

            toggleUpdateDialog(item){
                if(item){
                    this.tempData = {...item};
                    this.tempData.house_type_id = this.tempData.louverhouse.map(res => res.house_type_id)
                    this.dialogUpdate = true;
                }else{
                    this.dialogUpdate = false;
                }
            },

            Update(){
                if(this.$refs.Update.validate()){
                    const myForm = document.getElementById('Update');
                    const formdata = new FormData(myForm);
                    const id = this.tempData.id

                    axios({
                        method: 'POST',
                        url: `/api/louver_items/update/${id}`,
                        data: formdata
                    }).then(() => {
                        this._getLouverItems();
                        this.dialogUpdate = false;
                    })
                }
            },

            toggleDialogDelete(val){
                this.dialogDelete = val;
            },

            Delete(){
                axios({
                    method: 'POST',
                    url: '/api/louver_items/delete',
                    data: {ids : this.selectedData}
                }).then(() => {
                    this._getLouverItems();
                    this.dialogDelete = false;
                })
            }
        },

        mounted() {
            this._getLouverItems().then(() => {
                this._getHouseTypes();
            })
        },

        watch:{
            dialogStore(value){
                if( ! value ) this.$refs.Store.reset();
            },

            dialogUpdate(value){
                if( ! value ) this.$refs.Update.reset();
            }
            
        }
    }
</script>

<style scoped>


</style>